// extracted by mini-css-extract-plugin
export default {"wrapper":"PolicyPages_wrapper__j8M0N","wrapperInner":"PolicyPages_wrapperInner__pre9N","faqParagraphPadding":"PolicyPages_faqParagraphPadding__qWi1A"};